
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.713 6.207c0-.02-.012-.039-.013-.06h6.371c.727 1.874.939 3.13.929 3.955-1.485-.196-5.047-.877-7.544-3.091.148-.239.257-.503.257-.804zm-1.558 3.917v1.656l1.441.83-.442.763-1.886-1.081v-2.168h.887zm-.296 4.613a2.859 2.859 0 002.867-2.85 2.861 2.861 0 00-2.867-2.85 2.859 2.859 0 00-2.867 2.85 2.858 2.858 0 002.867 2.85zm.25-6.939a4.118 4.118 0 013.478 2.331c1.935.885 3.848 1.267 4.988 1.43a1.168 1.168 0 01-.045.039l-2.647 3.028-2.386-.819A4.123 4.123 0 016.859 16c-2.285 0-4.138-1.842-4.138-4.114 0-.247.032-.487.074-.723l-1.046-.358s-2.14-3.642.545-7.715C4.977-.985 11.577-1.525 14.37 4.496c.025.053.043.098.067.151H7.143c-.867 0-1.568.699-1.568 1.56 0 .832.687 1.526 1.512 1.572.007.007.015.012.021.02z","mask":"url(#a)","fill-rule":"evenodd"}})])
          )
        }
      }
    